export default "__VITE_ASSET__CM4VzliV__"